import React from 'react';

import Button from 'brandComponents/Button';
import Icon from 'brandComponents/Icon';

import {IPlayButtonProps} from './IPlayButton';

const PlayButton = ({setIsPlaying, isPlaying, icons} :IPlayButtonProps) => {
	return (
		<Button
			classNames="play-button"
			onClick={(e) => {
				e.preventDefault();
				e.stopPropagation();
				setIsPlaying(!isPlaying);
			}}
		>
			{isPlaying
				? <Icon
					name={icons.pause}
					height={icons.height}
					width={icons.width}
				/>
				: <Icon
					name={icons.play}
					height={icons.height}
					width={icons.width}
				/>
			}
		</Button>
	);
};

export default PlayButton;
